import { useCallback, useEffect, useState } from "react";

/**
 * Gestiona:
 * - filesCaceria[] paralelo a form.cacerias[]
 * - seleccionar archivo local por cacería
 * - limpiar rutaDocumento en el form
 * - borrar archivo en servidor (via deleteFileByUrl)
 */
export function useCaceriasFiles({ cacerias, setForm, deleteFileByUrl }) {
    const [filesCaceria, setFilesCaceria] = useState([]);

    // Mantener filesCaceria alineado con el tamaño de cacerias
    useEffect(() => {
        setFilesCaceria((prev) => {
            const next = [...prev];

            if (next.length < cacerias.length) {
                while (next.length < cacerias.length) next.push(null);
            } else if (next.length > cacerias.length) {
                next.length = cacerias.length;
            }

            return next;
        });
    }, [cacerias.length]);

    const handleCaceriaFileChange = useCallback((idx, file) => {
        setFilesCaceria((prev) => {
            const next = [...prev];
            next[idx] = file || null;
            return next;
        });
    }, []);

    const clearRutaDoc = useCallback(
        (idx) => {
            setForm((prev) => {
                const updated = [...(prev.cacerias || [])];
                if (!updated[idx]) return prev;
                updated[idx] = { ...updated[idx], rutaDocumento: "" };
                return { ...prev, cacerias: updated };
            });

            // también limpiamos el archivo local seleccionado
            handleCaceriaFileChange(idx, null);
        },
        [setForm, handleCaceriaFileChange]
    );

    const deleteRutaDocServer = useCallback(
        async (idx) => {
            const url = cacerias?.[idx]?.rutaDocumento;
            if (!url) return clearRutaDoc(idx);

            // confirmación
            if (!window.confirm("Esto borrará el archivo del servidor. ¿Continuar?")) return;

            try {
                await deleteFileByUrl(url);
                clearRutaDoc(idx);
                alert("Archivo borrado del servidor");
            } catch (e) {
                console.error(e);
                alert("No se pudo borrar el archivo en el servidor");
            }
        },
        [cacerias, deleteFileByUrl, clearRutaDoc]
    );

    return {
        filesCaceria,
        handleCaceriaFileChange,
        clearRutaDoc,
        deleteRutaDocServer,
    };
}
